import React, { useEffect } from "react";
import TableDragSelect from "react-table-drag-select";
import "react-table-drag-select/style.css";
import "./App.css";
import { exportComponentAsJPEG } from "react-component-export-image";
import Calculator from "awesome-react-calculator";
import defaultColorsState from "./colors.json";
import { Button, ButtonDropdown, Page, Grid, Spacer, Divider, Card, Drawer, Textarea, Keyboard, useToasts } from "@geist-ui/react";

const App = () => {

  const gridWidth = 10;
  const gridHeight = 10;

  const [showCalculator, setShowCalculator] = React.useState(false);
  const [showInstructions, setShowInst] = React.useState(false);

  const [showUnusedColors, setShowUnusedColors] = React.useState(true);

  const [cellsSelected,] = React.useState([...Array(gridHeight)].map(e => Array(gridWidth).fill(false)));

  const [colorPalette, setColorPalette] = React.useState(defaultColorsState);

  const [selectedColorID, setSelectedColorID] = React.useState(0);
  const [selectedGridColors, setSelectedGridColors] = React.useState([...Array(gridHeight)].map(e => Array(gridWidth).fill(0)));

  const [freq, setFreq] = React.useState([...Array(colorPalette.length).fill(0)]);

  const [gridHistory, setGridHistory] = React.useState([]);

  const [title, setTitle] = React.useState("");
  const [desc, setDesc] = React.useState("");

  const calculateProbabilities = () => {

    const frequency = [...Array(colorPalette.length)].map(_ => 0);

    selectedGridColors.forEach((row, _) => {
      row.forEach((color, _) => {
        frequency[color]++;
      });
    });

    const currColorPalette = copyOf(colorPalette);

    frequency.forEach((freq, index) => {
      const color = currColorPalette[index];
      color.percent = Math.round(freq / (gridWidth * gridHeight) * 100);
    });

    setColorPalette(currColorPalette);
  }

  const combineColors = (colorsA, colorsB) => {
    colorsA.forEach((color, index) => {
      color.percent = Math.round((color.percent + colorsB[index].percent) / 2);
      color.title = color.title ? color.title : colorsB[index].title;
      color.desc = color.desc ? color.desc : colorsB[index].desc;
    })
    return colorsA;
  }

  const newGrid = (colorArray) => {
    const newGrid = [...Array(gridHeight)].map(e => Array(gridWidth).fill(0));
    let row = 0;
    let col = 0;
    colorArray.forEach((color, index) => {
      const colorID = color.id;
      let colorPercent = color.percent;
      while (colorPercent > 0) {
        newGrid[row][col] = colorID;
        colorPercent--;
        col++;
        if (col >= gridWidth) {
          col = 0;
          row++;
          if (row >= gridHeight) {
            row = 0;
          }
        }
      }
    });
    return newGrid;
  }


  const copyOf = (obj) => {
    return JSON.parse(JSON.stringify(obj));
  }

  const selectCells = cells => {
    const currSelectedGridColors = copyOf(selectedGridColors);

    // Save current state to history.
    setGridHistory(gridHistory => [...gridHistory, copyOf(selectedGridColors)]);

    // Update color of selected cells
    cells.forEach((rows, rowIndex) => {
      rows.forEach((cell, cellIndex) => {
        if (cell) {
          currSelectedGridColors[rowIndex][cellIndex] = selectedColorID;
        }
      });
    });

    // Save new state of colors.
    setSelectedGridColors(currSelectedGridColors);
  }

  const undo = () => {
    if (gridHistory.length > 0) {
      const lastGridState = gridHistory[gridHistory.length - 1];
      setSelectedGridColors(copyOf(lastGridState));
      setGridHistory(gridHistory.slice(0, gridHistory.length - 1));
    }
  }

  const exportGrid = () => {
    const collectionCells = copyOf(selectedGridColors);
    const colors = copyOf(colorPalette);
    const data = {"cells": collectionCells, "colors": colors, "title": title, "desc": desc}
    const jsonData = JSON.stringify(data);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "grid.json";
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const importGrid = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "application/json";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const data = JSON.parse(text);
        setColorPalette(data.colors)
        setSelectedGridColors(data.cells)
        setTitle(data.title)
        setDesc(data.desc)
      }
      reader.readAsText(file);
    };
    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }

  const addGrid = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "application/json";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const data = JSON.parse(text);
        //Has to come before setSelectedGridColors because of side effects.
        const newColorPalette = combineColors(colorPalette, data.colors);
        const newCells = newGrid(newColorPalette)
        setColorPalette(newColorPalette)
        setSelectedGridColors(newCells)
      }
      reader.readAsText(file);
    };
    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }



  const pickARandomPoint = () => {
    const randomRow = Math.floor(Math.random() * gridHeight);
    const randomCol = Math.floor(Math.random() * gridWidth);
    const element = document.getElementById(randomRow + "-" + randomCol);

    element.style.border = "6px solid " + colorPalette[selectedColorID].hex;
    setTimeout(() => {
      element.style.border = "5px solid white";
    }, 1000);
  }

  function KeyPress(e) {
    var evtobj = e
    if (evtobj.keyCode === 90 && evtobj.ctrlKey) undo();
  }

  document.onkeydown = KeyPress;

  const changeColor = (id) => {
    setSelectedColorID(id);
  }

  const handleGridRightClick = (e) => {
    e.preventDefault();
    setSelectedGridColors(selectedGridColors => {
      const id = e.target.id
      if (id) {
        const [row, col] = id.split("-");
        if (row && col && row >= 0 && col >= 0 && row < gridHeight && col < gridWidth) {
          changeColor(selectedGridColors[row][col]);
        }
      }
      return selectedGridColors;
    })
  }

  useEffect(() => {
    calculateProbabilities();

    const frequency = [...Array(colorPalette.length)].map(_ => 0);
    selectedGridColors.forEach((row, _) => {
      row.forEach((color, _) => {
        frequency[color]++;
      });
    });

    setFreq(frequency);

  }, [selectedGridColors]);

  useEffect(() => {
    var style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    style.sheet.insertRule('.table-drag-select td.cell-being-selected{border:  5px solid ' + colorPalette[selectedColorID].hex + ';}', 0);
  }, [selectedColorID]);

  useEffect(() => {
    selectedGridColors.forEach((row, i) => {
      row.forEach((cell, j) => {
        const element = window.document.getElementById(`${i}-${j}`);
        element.style.backgroundColor = colorPalette[selectedGridColors[i][j]].hex;
      });
    });
    return;
  }, [selectedGridColors, colorPalette]);

  useEffect(() => {
    changeColor(1);
  }, []);

  const [, setToast] = useToasts();

  useEffect(() => {
    setToast({
      text: 'This is supposed to be a 10x10 grid. If it isn\'t, it\'s because your screen is too zoomed in.',
      type: 'error',
      actions: [
        {
          'name': 'Got it!',
          'passive': true,
          'handler': (e, cancel) => cancel()
        }
      ],
    })
  }, [])  

  const componentRef = React.useRef();

  return (
    <div>
      <Page>
        <h2>Probability Mass App </h2>
        <Button auto onClick={() => setShowInst(!showInstructions)}>{!showInstructions ? "Show " : "Hide "}Instructions</Button>
        <Spacer w={0.5} inline />
        <ButtonDropdown>
          <ButtonDropdown.Item main onClick={() => exportComponentAsJPEG(componentRef, { fileName: "image" })}>Export as JPEG</ButtonDropdown.Item>
          <ButtonDropdown.Item onClick={() => exportGrid()}>Export as JSON</ButtonDropdown.Item>
          <ButtonDropdown.Item onClick={() => importGrid()}>Import JSON</ButtonDropdown.Item>
          <ButtonDropdown.Item onClick={() => addGrid()}>Add JSON to Grid</ButtonDropdown.Item>
        </ButtonDropdown>
        <Spacer w={0.5} inline />
        <Button auto onClick={() => pickARandomPoint()} >Pick Random Point</Button>
        <Spacer w={0.5} inline />
        <Button auto onClick={() => undo()}> Undo </Button>
        <Spacer w={0.5} inline />
        <Button auto onClick={() => setShowCalculator(true)} >Calculator</Button>
        <Spacer w={0.5} inline />
        <Button auto onClick={() => setShowUnusedColors(!showUnusedColors)} >{!showUnusedColors ? "Show" : "Hide"} unused colors</Button>

        {showInstructions &&
          <Card shadow>
            <Spacer h={1} />
            <h4>Instructions</h4>
            {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p> */}
            {/* List of dummy text*/}
            <ul>
              <li>Each square of the grid represents 1%. </li>
              <li>Click on a color to the right, or right-click on a color on the grid, to select it. </li>
              <li>Click or click-drag on the grid to paint that color onto the grid. Ctrl-z to undo. </li>
              <li>If some of the grid is hidden by the box on the right, zoom out to fix the problem, for example by using   <Keyboard>Ctrl</Keyboard>+<Keyboard>-</Keyboard>
              </li>
            </ul>
          </Card>
        }

        <Divider />
        <Spacer h={1} />
        <div ref={componentRef}>

          {/* Title and description */}
          <Grid.Container >
            <Grid xs={24}>

              <Textarea rows="1" resize="both" scale={6 / 3} placeholder="Title" value={title} onChange={(e) => {setTitle(e.target.value)}} width="30%" />
            </Grid>
            <Spacer h={1} />
            <Grid xs={24}>
              <Textarea resize="both" placeholder="Description" value={desc} onChange={(e) => {setDesc(e.target.value)}} width="40%" />
            </Grid>
          </Grid.Container>

          <Spacer h={1} />

          <Grid.Container >
            <div className="flex-container">
              <div className="flex-item1">
                <Grid >
                  <div>
                    <TableDragSelect
                      value={cellsSelected}
                      onChange={selectCells}
                      style={{ width: "33em", height: "20%" }}
                    >
                      {[...Array(gridHeight)].map((_, i) => (
                        <tr key={i}>
                          {[...Array(gridWidth)].map((_, j) => (
                            <td key={`${i}-${j}`} id={`${i}-${j}`} onContextMenu={handleGridRightClick} />
                          ))}
                        </tr>
                      ))}
                    </TableDragSelect>
                  </div>
                </Grid>
              </div>
              {/* <Spacer w={2} inline /> */}
              <div className="flex-item2">
                <Grid >
                  <Card width="100%">
                    <Grid.Container>
                      {colorPalette.map((color, i) => (
                        (showUnusedColors || (!showUnusedColors && freq[i] !== 0)) && <>
                          <Grid xs={2}>
                            {color.percent}%
                          </Grid>
                          <Grid xs={3}>
                            <Button scale={1} auto style={{ backgroundColor: color.hex, border: selectedColorID === i ? "3px solid black" : "" }} onClick={() => changeColor(color.id)} />
                          </Grid>
                          <Grid xs={7}>
                            <Textarea placeholder="Title" rows="1" height="90%" resize="both" value={color.title} onChange={(e) => {
                              setColorPalette(colorPalette.map((color, j) => {
                                if (j === i) {
                                  return { ...color, title: e.target.value }
                                }
                                return color;
                              }))
                            }} />
                          </Grid>

                          <Grid xs={12}>
                            <Textarea resize="both" width="100%" height="90%" placeholder="Description"
                              value={color.desc}
                              onChange={(e) => {
                                setColorPalette(colorPalette.map((color, j) => {
                                  if (j === i) {
                                    return { ...color, desc: e.target.value }
                                  }
                                  return color;
                                }))
                              }}
                            />
                          </Grid>

                        </>))
                      }
                    </Grid.Container>
                  </Card>
                </Grid>
              </div>
            </div>

          </Grid.Container>
        </div>
      </Page>

      <Drawer visible={showCalculator} onClose={() => setShowCalculator(false)} keyboard disableBackdropClick placement="right">
        <Drawer.Title>Calculator</Drawer.Title>
        <Drawer.Content>
          <div style={{ height: '48rem', width: '30rem' }}>
            <Calculator />
          </div>
          <Spacer h={1} />
          <Button onClick={() => setShowCalculator(false)}> Close / (Press Esc) </Button>
        </Drawer.Content>
      </Drawer>

    </div >
  );
};

export default App;